export default __webpack_public_path__ + "static/media/I0004.cdad46d3.png";